import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "button";
  static values = {
    disabled: Boolean,
    visible: { type: Boolean, default: true },
  }

  connect() {
    super.connect();
    this.isConnected = true;
    this.isConnectedToBridge = false;
    this.bridgeData = this.#bridgeData();
    this.#syncVisibility();
  }

  disconnect() {
    this.isConnected = false;
    this.#notifyBridgeOfDisconnect();
    super.disconnect();
  }

  // Called when disabled value changes - re-send connect to update native button
  disabledValueChanged() {
    if (this.isConnected && this.visibleValue && this.hasDisabledValue) {
      this.#notifyBridgeOfConnect();
    }
  }

  visibleValueChanged() {
    if (this.isConnected) {
      this.#syncVisibility();
    }
  }

  // Public method to programmatically update disabled state
  setDisabled(disabled) {
    this.disabledValue = disabled;
  }

  setVisible(visible) {
    this.visibleValue = visible;
  }

  #syncVisibility() {
    if (this.visibleValue) {
      this.#notifyBridgeOfConnect();
    } else {
      this.#notifyBridgeOfDisconnect();
    }
  }

  #notifyBridgeOfConnect() {
    this.bridgeData = this.#bridgeData();
    this.isConnectedToBridge = true;

    this.send(
      "connect",
      this.bridgeData,
      () => {
        this.element.click();
      },
    );
  }

  #notifyBridgeOfDisconnect() {
    if (this.isConnectedToBridge && this.bridgeData?.removable) {
      this.isConnectedToBridge = false;
      this.send("disconnect", this.bridgeData, () => { });
    }
  }

  #bridgeData() {
    const element = this.bridgeElement;
    const image = element.bridgeAttribute("ios-image");
    const side = element.bridgeAttribute("side") || "right";
    const activeTitle = element.bridgeAttribute("active-title");
    const hidesSharedBackground = element.bridgeAttribute("hides-shared-background") === "true";
    const replacesAll = element.bridgeAttribute("replaces-all") === "true";
    const systemStyle = element.bridgeAttribute("system-style");
    const id = element.bridgeAttribute("id");
    const removable = element.bridgeAttribute("removable") === "true";

    // Check for disabled state from Stimulus value or data attribute
    const disabled = this.hasDisabledValue
      ? this.disabledValue
      : element.bridgeAttribute("disabled") === "true";

    return { id, title: element.title, activeTitle, image, side, hidesSharedBackground, replacesAll, systemStyle, disabled, removable };
  }
}
